export const TABLE_SETTING_KEYS = {
  directoryTab: 'tableDirectoryTab',
  archivesLists: 'tableArchivesLists',
  contractorsTab: 'tableContractorsTab',
  quotaReportTab: 'tableQuotaReportTab',
  photoControlTab: 'tablePhotoControlTab',
  templatesEditor: 'tableTemplatesEditor',
  currentListsTab: 'tableCurrentListsTab',
  registryPageInner: 'tableRegistryPageInner',
  totalMonitoringTab: 'tableTotalMonitoringTab',
  monitoringSchedule: 'tableMonitoringSchedule',
  competitorsPricesTab: 'tableCompetitorsPricesTab',
  regularMonitoringTab: 'tableRegularMonitoringTab',
  processingResultsPage: 'tableProcessingResultsPage',
  contractorSectionPage: 'tableContractorSectionPage',
  monitoringRegistryPage: 'tableMonitoringRegistryPage',
  externalProductsCatalog: 'tableExternalProductsCatalog',
  managingMonitoringsPage: 'tableManagingMonitoringsPage',
  registryPageArchivesInner: 'tableRegistryPageArchivesInner',
  checkingPricesCompetitors: 'tableCheckingPricesCompetitors',
  connectionsContractorsTab: 'tableConnectionsContractorsTab',
  internalTasksPage: 'tableInternalTasksPage',
  transferResultsPage: 'tableTransferResultsPage'
} as const
